import React, { useCallback, useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { color } from 'styles/utils';
import MultidieItem from './MultidieItem';
import { IToothShade, Tooth } from 'lib/types/projectTypes';
import cx from 'classnames';

interface MultidiePlateProps {
  isListPage?: boolean;
  isComplete?: boolean;
  isEdit: boolean;
  teeth: {
    value: object[] | any;
    onChange: (e: any) => void;
    setValue: (value: object[] | any) => void;
  };
  tooth: {
    value: Tooth;
    onChange: (e: any) => void;
    setValue: (value: Tooth) => void;
  };
  copyData?: {
    value: object | null | any;
    onChange: (e: any) => void;
    setValue: (value: object) => void;
  };
  teethContextActions?: {
    value: {
      copy: {
        active: boolean;
        hidden: boolean;
      };
      paste: {
        active: boolean;
        hidden: boolean;
      };
      delete: {
        active: boolean;
        hidden: boolean;
      };
    };
    setValue: (f: (draft: any) => any) => void;
  };
  onToggleTooth?: (value: number) => void;
  onChangeToothValue?: (value: object | any) => void;
}

const MultidiePlate = ({
  isListPage = false,
  isComplete = false,
  isEdit,
  teeth,
  tooth,
  copyData,
  teethContextActions,
  onToggleTooth,
  onChangeToothValue = () => {},
}: MultidiePlateProps) => {
  let index: number = 0;
  return (
    <StyledMultidiePlate data-component-name="MultidiePlate" className="multidiePlate__container">
      <div className={cx('multidiePlate__box', { useList: isListPage, useComplete: isComplete })}>
        {Array.from({ length: 7 }).map(() => {
          index++;
          const selected = tooth.value.number === index + 100;
          return (
            <div
              className={cx(`multidiePlate__item_box die${index}`, {
                useList: isListPage,
                useComplete: isComplete,
              })}
              key={index}
            >
              <MultidieItem
                isListPage={isListPage}
                isComplete={isComplete}
                isSelected={selected}
                isEdit={isEdit}
                number={index + 100}
                teethIndex={index}
                numberPosition={`die${index}`}
                tooth={tooth}
                teeth={teeth}
                onToggleTooth={onToggleTooth}
                copyData={copyData}
                teethContextActions={teethContextActions}
              />
            </div>
          );
        })}
      </div>
    </StyledMultidiePlate>
  );
};

const StyledMultidiePlate = styled.div<{}>`
  .multidiePlate__box {
    border-radius: 50%;
    background-color: #000000;
    position: relative;
    width: 440px;
    height: 440px;

    &.useList {
      width: 140px;
      height: 140px;
    }
    &.useComplete {
      width: 330px;
      height: 330px;
    }
    .multidiePlate__item_box {
      position: absolute;
      &.die1 {
        top: 40px;
        left: 50%;
        transform: translateX(-50%);
        &.useList {
          top: 10px;
        }
        &.useComplete {
          top: 30px;
        }
      }
      &.die2 {
        left: 75%;
        top: 33%;
        transform: translate(-50%, -50%);
      }
      &.die6 {
        left: 25%;
        top: 33%;
        transform: translate(-50%, -50%);
      }

      &.die3 {
        left: 75%;
        top: 66%;
        transform: translate(-50%, -50%);
      }
      &.die5 {
        left: 25%;
        top: 66%;
        transform: translate(-50%, -50%);
      }
      &.die4 {
        bottom: 40px;
        left: 50%;
        transform: translateX(-50%);
        &.useList {
          bottom: 10px;
        }
        &.useComplete {
          bottom: 30px;
        }
      }

      &.die7 {
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
`;

export default React.memo(MultidiePlate);
